<div class="carousel">
  <button type="button" class="control close" (click)="close()">
    <palantir-icon name="close-outline" />
  </button>

  @for (slide of slides; track $index; let i = $index) {
    @if (i === currentSlide && !mediaErrors[i] && slide.format === 'image') {
      <img
        appImageLoad
        (error)="palantirCarouselService.handleMediaError($event, i)"
        [src]="slide.src"
        alt="Slide {{ i }}"
        class="slide"
        [@carouselAnimation]
      />
    }

    @if (i === currentSlide && !mediaErrors[i] && slide.format === 'video') {
      <video class="slide" muted controls>
        <source [src]="slide.src" />
      </video>
    }

    @if (mediaErrors[i] && i === currentSlide) {
      <div class="slide not-available" [@carouselAnimation]>
        <div class="not-available-content">
          <span class="not-available-content-title">{{ texts.notAvailable.title }}</span>
          <span class="not-available-content-description">{{
            texts.notAvailable.description
          }}</span>
          <a
            [href]="slide.src"
            target="_blank"
            rel="noopener noreferrer"
            download
            class="download-button"
          >
            <palantir-icon name="download" class="download-button-icon" />
            <span class="download-button-text">{{ texts.downloadButton }}</span>
          </a>
        </div>
      </div>
    }
  }

  <button type="button" class="control prev" (click)="onPreviousClick()">
    <palantir-icon class="control-icon" name="arrow-backward-outline" />
  </button>
  <button type="button" class="control next" (click)="onNextClick()">
    <palantir-icon class="control-icon" name="arrow-forward-outline" />
  </button>
</div>
